import { useClients } from '@entities/clients';
import { useClientIdsSelect } from '@entities/clients/heplers.ts';
import cn from 'classnames';
import type React from 'react';
import { useLayoutEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Tooltip } from '@mui/material';
import { useClientGroupPageRedirect } from '@pages/clients/group-page/helpers.ts';
import { useTempClientFormPageRedirect } from '@features/clients/client-form/ui/form/helpers.ts';
import { ClientInfoWithList } from '@features/clients/client-info-with-list/index.tsx';
import { ToolbarDynamicButtons } from '@features/clients/client-toolbar-dynamic-buttons';
import { useGroupLoader } from '@features/clients/editor-group/model/use-group-loader.ts';
import { Search, useFilter } from '@features/common';
import { Add, ArrowShortLeft, Mark, Search as SearchIcon } from '@shared/assets';
import { IconButton, PageHead, PageTitle } from '@shared/ui';
import { MainMenu } from '../groups-page/dropdown-menu';
import { AddUserMenu } from './dropdown-menu';
import * as st from './styles.module.scss';

export const GroupPage: React.FC = () => {
  const { groupId } = useParams();

  const { doRedirectOnPrevPage } = useClientGroupPageRedirect();

  const { isMobile, isMobileWithSelecting, isSelecting, toggleSelectionMode } =
    useClientIdsSelect();

  const { search, onSearch, searchNotes, onSearchNotes } = useFilter();

  const { nameClients } = useClients();

  const { redirectOnClientForm } = useTempClientFormPageRedirect();

  const { group } = useGroupLoader(Number(groupId));

  const [addUsers, setAddUsers] = useState<boolean>(false);

  const listParamsGroup = { search: search, custom_group: groupId };

  const [isSearchMobile, setIsSearchMobile] = useState(false);

  useLayoutEffect(() => {
    isSelecting && toggleSelectionMode();
  }, []);

  if (group)
    return (
      <>
        {!isSearchMobile && (
          <>
            <PageTitle title={isSelecting ? `${group.name} / Выбор` : `${group.name}`} />
            <PageHead
              Left={
                // !(isSelecting && windowWidth < 570) ? (
                <IconButton
                  variant="dark"
                  onClick={() => {
                    if (isSelecting) {
                      toggleSelectionMode();
                    } else {
                      doRedirectOnPrevPage('/clients/groups');
                    }
                  }}
                >
                  <ArrowShortLeft />
                </IconButton>
                // ) : (
                //   <></>
                // )
              }
              LeftSecondLine={
                isMobileWithSelecting ? (
                  <ToolbarDynamicButtons withCount={false} withActionButton={false} />
                ) : null
              }
              Right={
                <>
                  {!isMobile ? (
                    <Search
                      search={search}
                      onSearch={onSearch}
                      titles={nameClients}
                      additionalChildren={<ToolbarDynamicButtons />}
                    />
                  ) : (
                    <>
                      <ToolbarDynamicButtons withButtons={!isMobile} />
                      <IconButton
                        variant="mobile"
                        onClick={() => setIsSearchMobile(!isSearchMobile)}
                      >
                        <SearchIcon />
                      </IconButton>
                    </>
                  )}
                  {/*<IconButton variant="dark">*/}
                  {/*  <SortIcon />*/}
                  {/*</IconButton>*/}
                  {/*<IconButton variant="dark">*/}
                  {/*  <FilterIcon />*/}
                  {/*</IconButton>*/}
                  {!addUsers && (
                    <IconButton
                      className={cn(isSelecting && st.checkbox)}
                      variant={isSelecting ? 'active' : 'dark'}
                      onClick={() => toggleSelectionMode()}
                    >
                      <Mark />
                    </IconButton>
                  )}
                  {!addUsers && group.special_type === null && (
                    <AddUserMenu
                      groupId={Number(groupId)}
                      setAddUsers={setAddUsers}
                      toggleSelectionMode={toggleSelectionMode}
                    />
                  )}
                  {group.special_type === null && <MainMenu groupId={Number(groupId)} />}
                  {group.special_type === 'without_group' && (
                    <Tooltip title="Добаить">
                      <div>
                        <IconButton
                          variant="dark"
                          onClick={() => {
                            redirectOnClientForm(`/clients/clients/edit/new`);
                          }}
                        >
                          <Add />
                        </IconButton>
                      </div>
                    </Tooltip>
                  )}
                </>
              }
            />
          </>
        )}
        {isSearchMobile && (
          <>
            <PageTitle title="Поиск" />
            <PageHead
              Left={
                <IconButton
                  variant="dark"
                  onClick={() => {
                    setIsSearchMobile(!isSearchMobile);
                    onSearch('');
                  }}
                >
                  <ArrowShortLeft />
                </IconButton>
              }
              Right={<Search mobile search={search} onSearch={onSearch} titles={nameClients} />}
            />
          </>
        )}
        <ClientInfoWithList
          isHeaderWithToLines={isMobileWithSelecting}
          listParams={listParamsGroup}
          searchNotes={searchNotes}
          onSearchNotes={onSearchNotes}
        />
      </>
    );
};

export default GroupPage;
